import { render, staticRenderFns } from "./UppyUpload.vue?vue&type=template&id=1b344b58&"
import script from "./UppyUpload.vue?vue&type=script&lang=js&"
export * from "./UppyUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports